import { atom } from "recoil";

export const addStateEmployeeType = atom({
  key: "addStateEmployeeType",
  default: false,
});
export const editStateEmployeeType = atom({
  key: "editStateEmployeeType",
  default: false,
});
export const rowEditIdStateEmployeeType = atom({
  key: "rowEditIdStateEmployeeType",
  default: null,
});
export const disableButtonStateEmployeeType = atom({
  key: "disableButtonStateEmployeeType",
  default: false,
});

export const selectedRowsStateEmployeeType = atom({
  key: "selectedRowsStateEmployeeType",
  default: [],
});

export const setFilterTextEmployeeType = atom({
  key: "setFilterTextEmployeeType",
  default: "",
});
